import { initialState } from "../initialState";
import * as RequestNewDueDateActions from "./requestNewDueDateActions";

export const requestNewDueDateReducer = (state = initialState.requestNewDueDate, action) => {
    switch (action.type) {
        case RequestNewDueDateActions.REQUEST_NEW_DUE_DATE:
            return Object.assign({}, state, {
                requestNewDueDate: action.requestNewDueDate,
            });

        case RequestNewDueDateActions.REQUEST_NEW_DUE_DATE_SUCCEEDED:
            return Object.assign({}, state, {
                requestNewDueDateResponse: action.requestNewDueDateResponse,
            });
        case RequestNewDueDateActions.REQUEST_NEW_DUE_DATE_FAILED:
            return initialState.requestNewDueDate.requestNewDueDateResponse;

        default:
            return state;
    }
};
